import { ADD_PRODUCTS } from '../actions';

const initialState = {};

export default function (state = initialState, action) {
	switch (action.type) {
		case ADD_PRODUCTS:
			var products;
			action.payload &&
				action.payload.forEach(product => {
					products = {
						...products,
						[product._id]: product,
					};
				});

			return {
				...state,
				...products,
			};
		default:
			return state;
	}
}
